import { User } from '../types/auth.types';
import {
  ROLE_IDS,
  SITE_RESTRICTED_ROLES,
  type RoleId,
} from '@/domain/constants/roles';

/**
 * ユーザーが現場ユーザー（SITE_USER）かどうかを判定
 * SITE_VIEWERは含まない
 */
export function isSiteUser(user: User | null): boolean {
  return user?.roleId === ROLE_IDS.SITE_USER;
}

/**
 * ユーザーが現場閲覧者（SITE_VIEWER）かどうかを判定
 */
export function isSiteViewer(user: User | null): boolean {
  return user?.roleId === ROLE_IDS.SITE_VIEWER;
}

/**
 * ユーザーがサイト制限ロール（SITE_USER または SITE_VIEWER）かどうかを判定
 */
export function isSiteRestrictedUser(user: User | null): boolean {
  if (!user) return false;
  return SITE_RESTRICTED_ROLES.includes(user.roleId as RoleId);
}

/**
 * ユーザーが管理者（開発者またはMCMユーザー）かどうかを判定
 */
export function isAdminUser(user: User | null): boolean {
  return user?.roleId === ROLE_IDS.DEV_USER || user?.roleId === ROLE_IDS.MCM_USER;
}

/**
 * ユーザーがアクセス可能なサイトIDのリストを返す
 * 管理者は全サイト、サイト制限ロールは割り当てサイトのみ
 */
export function getAccessibleSiteIds(user: User | null): number[] | 'all' {
  if (!user) return [];

  if (isAdminUser(user)) {
    return 'all';
  }

  if (isSiteRestrictedUser(user) && user.siteId) {
    // 値オブジェクトをプリミティブ型に変換
    return [user.siteId.toPrimitive()];
  }

  return [];
}

/**
 * ユーザーが特定のサイトにアクセス可能かどうかを判定
 */
export function canAccessSite(user: User | null, siteId: number): boolean {
  const accessibleSites = getAccessibleSiteIds(user);

  if (accessibleSites === 'all') {
    return true;
  }

  return Array.isArray(accessibleSites) && accessibleSites.includes(siteId);
}